<template>
  <div class="main-header p-2">
    <span />

    <p
      v-if="isModerating"
      class="main-header-title"
    >
      You’re moderating this presentation
    </p>

    <span>
      <AhaLogo
        class="text-base-0 hidden sm:inline-block"
        :use-default-color="false"
        viewBox="0 0 799 183"
        width="135"
        height="23"
      />
    </span>
  </div>
</template>

<script>
export default {
  props: {
    isModerating: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
.main-header {
  @apply h-full flex justify-between items-center px-3;

  background: rgba(0, 0, 0, 0.15);

  .main-header-title {
    @apply text-xs text-base-0 sm:pl-12;
  }
}
</style>
